export default __webpack_public_path__ + "static/media/coinflip.84dc0e02.png";